import React from 'react'
import Card from '../../../../../reusableComponents/cards/Card71'
import InstructorComp1 from './InstructorComp1'

const InstructorCard = ({ instructorData = {} }) => {
  return (
    <div>
        <Card
            showTitle={true}
            title="About the Instructor"
            showPrimaryButton={false}
            showSecondaryButton={false}
            showMenuButton={false}
            showSwapComponent1={true}
            swapContent1={<InstructorComp1 instructorData={instructorData} />}
            showSwapComponent2={false}
            showSwapComponent3={false}
            showDescription={true}
            description={instructorData?.bio || "No tutor assigned yet"}
        />
    </div>
  )
}

export default InstructorCard